module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Book.b4f431b6.eot";